export class UserDetailsCommon {
  public static leaveFormErrors = {
  'approver': '',
  'fromDate':  '',
  'leaveDays':  '',
  'leaveType':  '',
  'reason':  '',
  'toDate':  '',
  'id':  '',
  };
  public static leaveFormValidationMessages = {
  'approver':  {
    'required': 'mandatory field'
  },
  'fromDate':  { 'required': 'mandatory field'},
  'leaveDays':  { 'required': 'mandatory field'},
  'leaveType':  { 'required': 'mandatory field'},
  'reason':  { 'required': 'mandatory field'},
  'toDate':  {
    'required': 'mandatory field',
    'minDate' : 'toDate should be greater than fromDate'
  },
  'id':  { 'required': 'mandatory field'},
  };

  public static personalDetailsFormError ={
    'dateOfBirth':'',
    'bloodGroup': '',
    'panNumber': '',
    'aadharNumber': '',
    'qualification': '',
    'certificationType': '',
    'description':'',

    'personalEmail':'',
    'officalMobileNumber':'',
    'contactMobileNumber':'',

    'emergencyContactNumber1':'',
    'emergencyContactName1':'',
    'emergencyContactRelation1':'',

    'address':'',
    'city':'',
    'state':'',
    'postalCode':'',
    'country':'',
    'streetName':'',

  }

  public static personalDetailsValidationMessages ={
    'dateOfBirth': {
      'required': 'date of birth is required.',
      'ngbDate':''
      },
      'bloodGroup': {
        'required': 'blood group is required.'
      },
      'panNumber': {
        'required': 'pan number is required.',
        'pattern': 'invalid pan'
      },
      'aadharNumber': {
        'required': 'aadhar number is required.',
        'pattern': 'invalid aadhar'
      },
      'qualification': { 'required': 'qualification is required.'},
      'certificationType': { 'required': 'certification is required.'},
      'description': { 'required': 'description is required.'},

      'personalEmail': { 'required': 'personal email is required.'},
      'officalMobileNumber':{ 'required': 'official mobile no is required.'},
      'contactMobileNumber': { 'required': 'personal mobile no is required.'},

      'emergencyContactNumber1':{ 'required': 'emergency contact no is required.'},
      'emergencyContactName1':{ 'required': 'emergency contact name is required.'},
      'emergencyContactRelation1': { 'required': 'emergency contact realtion is required.'},

      'address': { 'required': 'address is required.'},
      'city':{ 'required': 'city is required.'},
      'state':{ 'required': 'state is required.'},
      'postalCode':{ 'required': 'pincode is required.'},
      'country':{ 'required': 'country is required.'},
      'streetName':{ 'required': 'mandatory field.'},
  }

}

